export default "__VITE_ASSET__f77794f8__"